/**
 * Keyboard mixin
 *
 * Добавляет логику для работы с клавиатурой
 *
 */

export default {
  methods: {
    async getKeyboardLocale() {
      try {
        const locale = await this.$robot.keyboardService.getLocale();
        return locale;
      } catch (e) {
        console.error('keyboardService.getLocale error: ', e);
        return '';
      }
    },
    async setKeyboardLocale(locale) {
      try {
        await this.$robot.keyboardService.setLocale(locale);
      } catch (e) {
        console.error('keyboardService.setLocale error: ', e);
      }
    },
    setEnglishKeyboard() {
      return this.setKeyboardLocale('en_US');
    },
  },
};
